export const achievements = [
  {
    icon: "ri-trophy-line",
    title: "Top Rated Mover in Nagarabhavi",
    text: "Consistently rated among the most recommended packers and movers around Nagarabhavi, Gnanabharathi and Nagarabhavi Ring Road.",
  },
  {
    icon: "ri-road-map-line",
    title: "500+ Moves Completed",
    text: "Households, offices, clinics and warehouse customers moved safely since 2009 across Bangalore and Karnataka.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "24 x 7 Customer Support",
    text: "A dedicated helpline that answers before, during and after your move so you are never left guessing.",
  },
  {
    icon: "ri-parent-line",
    title: "Family Run Since 2009",
    text: "Owned and operated by the same founding family, which is why accountability never gets outsourced.",
  },
];

export const coverageAreas = [
  "Nagarabhavi",
  "Gnanabharathi",
  "Rajajinagar",
  "Malleswaram",
  "Vijayanagar",
  "Jayanagar",
  "JP Nagar",
  "Banashankari",
  "Whitefield",
  "HSR Layout",
  "Vidyaranyapura",
  "Mysore Road",
  "Magadi Road",
  "NICE Road",
  "Seegehalli",
  "Giddenahalli",
  "Kannahalli",
  "Anikethana Nagara",
  "Hebbal",
  "Marathahalli",
  "Tumkur",
  "Mysore",
];

export const corporateClients = [
  "Codewing Solutions",
  "Sharda Healthcare",
  "Nagarabhavi Retail Mart",
  "Vertex Labs",
  "Sai Interiors",
  "Balaji Textiles",
];

export const certifications = [
  { icon: "ri-shield-check-line", title: "Transit Protection", text: "Your belongings are handled by trained crews and can be backed by transit cover as per your written estimate." },
  { icon: "ri-file-shield-2-line", title: "Written Estimates", text: "Every quote is documented item-wise, so what you are told is what you pay." },
  { icon: "ri-box-3-line", title: "In-House Packing Material", text: "We stock our own bubble wrap, cartons, foam and crates, so quality is never left to a third party." },
];